"use strict";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import Dropzone from "react-dropzone";
import Button from "react-bootstrap-button-loader";
import { Modal, DropdownButton, Dropdown } from "react-bootstrap";
import XLSX from "xlsx";
import Pagination from "react-js-pagination";

// constants
import { showError, showSuccess } from "ReduxErrorBar";
import { NEW_IMAGE_PATH, checkDateFormatYMD } from "Constants";
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

// actions
import {
  importScheduleModal,
  importSchedules,
  handleBulkEditModal,
} from "ContentActions";

// components
import ImportCell from "./schedule-import-cell";
import BetaFeature from "BetaFeature";
import ScheduleBulkEdit from "./schedule-bulk-edit";

const per_page_row = 10;
const sheetHeader = [
  "Date",
  "Track",
  "Title",
  "Start Time",
  "End Time",
  "Location",
  "Checkin Type",
  "Color",
  "Tags",
  "Speakers",
  "Session Type",
  "RSVP",
  "Capacity",
  "Description",
  "Main Video",
  "Main Video Restrict",
  "Other Video1",
  "Other Video1 Restrict",
  "Other Video2",
  "Other Video2 Restrict",
  "Other Video3",
  "Other Video3 Restrict",
  "Other Video4",
  "Other Video4 Restrict",
  "File1",
  "File2",
  "File3",
  "File4",
  "File5",
  "Send Push Befor #Minutes",
  "Send Push Text",
];

class ImportSchedules extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.state = {
      accept:
        "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      loading: false,
      processingData: false,
      hasData: false,
      importeddata: [],
      hasError: false,
      hasDataError: false,
      errorMessage: "",
      selectedPage: 1,
      paginatedData: {
        page: 0,
        per_page: 0,
        total: 0,
        total_pages: 0,
        data: [],
      },
      duplicateData: "update",
    };
  }

  openModal() {
    this.props.importScheduleModal({ show: true });
    this.retry();
  }

  openBulkEditModal = () => {
    // import modal close and states handled
    this.closeModal();

    // bulk edit modal handle
    this.props.handleBulkEditModal({ show: true });
  };

  closeModal = () => {
    this.props.importScheduleModal({ show: false });
    this.retry();
  };

  retry = () => {
    this.setState({
      processingData: false,
      hasData: false,
      hasError: false,
      hasDataError: false,
      errorMessage: "",
      loading: false,
    });
  };

  downloadSample = (type) => {
    let XLSX = require("xlsx");
    let sample = [
      {
        Date: "2022-01-15",
        Track: "PLUTO",
        Title: "Registration",
        "Start Time": "10:00",
        "End Time": "11:30",
        Location: "Online",
        "Checkin Type": "Self",
        Color: "#f0d9bc",
        Tags: "Tag1,Tag2,Tag3",
        Speakers: "FName1 LName1,FName2 LName2",
        "Session Type": "Public",
        RSVP: "No",
        Capacity: "Unlimited",
        Description: "Session description",
        "Main Video": "Youtube link or zoom id",
        "Main Video Restrict": "Yes",
        "Other Video1": "Youtube link or zoom id",
        "Other Video1 Restrict": "No",
        "Other Video2": "Youtube link or zoom id",
        "Other Video2 Restrict": "No",
        "Other Video3": "Youtube link or zoom id",
        "Other Video3 Restrict": "No",
        "Other Video4": "Youtube link or zoom id",
        "Other Video4 Restrict": "No",
        File1: "http://hub.eventify.io/assets/sample.pdf",
        File2: "http://hub.eventify.io/assets/sample.pdf",
        File3: "http://hub.eventify.io/assets/sample.pdf",
        File4: "http://hub.eventify.io/assets/sample.pdf",
        File5: "http://hub.eventify.io/assets/sample.pdf",
        "Send Push Befor #Minutes": "",
        "Send Push Text": "",
      },
      {
        Date: "2022-01-15",
        Track: "PLUTO",
        Title: "IoT",
        "Start Time": "11:30",
        "End Time": "13:30",
        Location: "Sydney",
        "Checkin Type": "Scan QR",
        Color: "#fdafbd",
        Tags: "Tag1,Tag2,Tag3",
        Speakers: "FName1 LName1,FName2 LName2",
        "Session Type": "Private",
        RSVP: "Yes",
        Capacity: "1000",
        Description: "Session description",
        "Main Video": "Youtube link or zoom id",
        "Main Video Restrict": "Yes",
        "Other Video1": "Youtube link or zoom id",
        "Other Video1 Restrict": "No",
        "Other Video2": "Youtube link or zoom id",
        "Other Video2 Restrict": "No",
        "Other Video3": "Youtube link or zoom id",
        "Other Video3 Restrict": "No",
        "Other Video4": "Youtube link or zoom id",
        "Other Video4 Restrict": "No",
        File1: "http://hub.eventify.io/assets/sample.pdf",
        File2: "http://hub.eventify.io/assets/sample.pdf",
        File3: "http://hub.eventify.io/assets/sample.pdf",
        File4: "http://hub.eventify.io/assets/sample.pdf",
        File5: "http://hub.eventify.io/assets/sample.pdf",
        "Send Push Befor #Minutes": "5",
        "Send Push Text": "Session will start in just 5 minutes",
      },
      {
        Date: "2022-01-15",
        Track: "JUPITER",
        Title: "Process Management",
        "Start Time": "11:00",
        "End Time": "14:30",
        Location: "Sydney",
        "Checkin Type": "Scan QR",
        Color: "#f0d9bc",
        Tags: "",
        Speakers: "FName1 LName1,FName2 LName2",
        "Session Type": "Public",
        RSVP: "Yes",
        Capacity: "Unlimited",
        Description: "Session description",
        "Main Video": "Youtube link or zoom id",
        "Main Video Restrict": "Yes",
        "Other Video1": "Youtube link or zoom id",
        "Other Video1 Restrict": "No",
        "Other Video2": "Youtube link or zoom id",
        "Other Video2 Restrict": "No",
        "Other Video3": "Youtube link or zoom id",
        "Other Video3 Restrict": "No",
        "Other Video4": "Youtube link or zoom id",
        "Other Video4 Restrict": "No",
        File1: "http://hub.eventify.io/assets/sample.pdf",
        File2: "http://hub.eventify.io/assets/sample.pdf",
        File3: "http://hub.eventify.io/assets/sample.pdf",
        File4: "http://hub.eventify.io/assets/sample.pdf",
        File5: "http://hub.eventify.io/assets/sample.pdf",
        "Send Push Befor #Minutes": "",
        "Send Push Text": "",
      },
      {
        Date: "2022-01-16",
        Track: "GALAXEN",
        Title: "Cloud Technology",
        "Start Time": "10:00",
        "End Time": "13:00",
        Location: "Sydney",
        "Checkin Type": "Self",
        Color: "#f0d9bc",
        Tags: "",
        Speakers: "",
        "Session Type": "Public",
        RSVP: "No",
        Capacity: "Unlimited",
        Description: "Session description",
        "Main Video": "Youtube link or zoom id",
        "Main Video Restrict": "Yes",
        "Other Video1": "Youtube link or zoom id",
        "Other Video1 Restrict": "No",
        "Other Video2": "Youtube link or zoom id",
        "Other Video2 Restrict": "No",
        "Other Video3": "Youtube link or zoom id",
        "Other Video3 Restrict": "No",
        "Other Video4": "Youtube link or zoom id",
        "Other Video4 Restrict": "No",
        File1: "http://hub.eventify.io/assets/sample.pdf",
        File2: "http://hub.eventify.io/assets/sample.pdf",
        File3: "http://hub.eventify.io/assets/sample.pdf",
        File4: "http://hub.eventify.io/assets/sample.pdf",
        File5: "http://hub.eventify.io/assets/sample.pdf",
        "Send Push Befor #Minutes": "",
        "Send Push Text": "",
      },
      {
        Date: "2022-01-16",
        Track: "GALAXEN",
        Title: "Lunch Break",
        "Start Time": "13:00",
        "End Time": "14:00",
        Location: "Sydney",
        "Checkin Type": "Self",
        Color: "#f0d9bc",
        Tags: "",
        Speakers: "",
        "Session Type": "Public",
        RSVP: "No",
        Capacity: "Unlimited",
        Description: "Session description",
        "Main Video": "Youtube link or zoom id",
        "Main Video Restrict": "Yes",
        "Other Video1": "Youtube link or zoom id",
        "Other Video1 Restrict": "No",
        "Other Video2": "Youtube link or zoom id",
        "Other Video2 Restrict": "No",
        "Other Video3": "Youtube link or zoom id",
        "Other Video3 Restrict": "No",
        "Other Video4": "Youtube link or zoom id",
        "Other Video4 Restrict": "No",
        File1: "http://hub.eventify.io/assets/sample.pdf",
        File2: "http://hub.eventify.io/assets/sample.pdf",
        File3: "http://hub.eventify.io/assets/sample.pdf",
        File4: "http://hub.eventify.io/assets/sample.pdf",
        File5: "http://hub.eventify.io/assets/sample.pdf",
        "Send Push Befor #Minutes": "10",
        "Send Push Text": "Session will start in just 10 minutes",
      },
    ];

    // console.log("sample updated", sample);
    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    // console.log("wb", wb);

    /* Create a worksheet */
    var ws = XLSX.utils.json_to_sheet(sample);
    var sheetName = "sample";

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    /* Generate xlsx files */
    if (type === "csv") {
      XLSX.writeFile(wb, "schedule_sample.csv");
    } else {
      XLSX.writeFile(wb, "schedule_sample.xlsx");
    }
  };

  onDrop = (files) => {
    let file = files[0];
    var Papa = require("papaparse/papaparse.min.js");
    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: function (results, file) {
          if (results.errors.length === 0) this.processCSV(results.data);
          else {
            // console.log("Error in File");
            this.props.showError(LocaleStrings.schedule_import_validation1);
          }
        }.bind(this),
        error: function (error, reason) {
          this.props.showError(LocaleStrings.schedule_import_validation1);
        },
      });
    } else {
      //debugger;
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });
        /* Update state */
        //this.setState({ data: data, cols: make_cols(ws['!ref']) });

        if (data.length === 0) {
          // console.log("Error in File");
          this.props.showError(LocaleStrings.schedule_import_validation1);
        } else {
          this.processXLS(data);
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    }
  };

  processXLS = (result) => {
    this.processCSV(result);
  };

  processCSV = (result) => {
    var { dates } = this.props;
    var header = result[0];
    let eventDate = dates.map((item) => item["scheduledate"]);
    // console.log("Result = ", result);

    this.setState({ processingData: true });
    if (header && header.length === sheetHeader.length) {
      let headerOk = true;
      sheetHeader.forEach((element, index) => {
        if (element != header[index]) {
          headerOk = false;
        }
      });

      if (headerOk) {
        var newArray = _.drop(result, 1);
        var modifiedArr = [];
        // console.log("newArray :- ", newArray);

        if (newArray.length > 0) {
          newArray.map((data, id) => {
            if (data.length > 1) {
              modifiedArr.push({
                rowno: id + 2,
                hasErrors: [],
                sessiondate:
                  data[0] && data[0] != "" ? data[0].toString().trim() : "",
                sessiontrack:
                  data[1] && data[1] != "" ? data[1].toString().trim() : "",
                sessiontitle:
                  data[2] && data[2] != "" ? data[2].toString().trim() : "",
                sessionstime:
                  data[3] && data[3] != "" ? data[3].toString().trim() : "",
                sessionetime:
                  data[4] && data[4] != "" ? data[4].toString().trim() : "",
                location:
                  data[5] && data[5] != "" ? data[5].toString().trim() : "",
                checkintype:
                  data[6] && data[6] != "" ? data[6].toString().trim() : "",
                colorid:
                  data[7] && data[7] != "" ? data[7].toString().trim() : "",
                tags: data[8] && data[8] != "" ? data[8].toString().trim() : "",
                speakers:
                  data[9] && data[9] != "" ? data[9].toString().trim() : "",
                sessiontype:
                  data[10] && data[10] != "" ? data[10].toString().trim() : "",
                rsvp:
                  data[11] && data[11] != "" ? data[11].toString().trim() : "",
                capacity:
                  data[12] && data[12] != "" ? data[12].toString().trim() : "",
                description:
                  data[13] && data[13] != "" ? data[13].toString().trim() : "",
                videolink:
                  data[14] && data[14] != "" ? data[14].toString().trim() : "",
                restrictstarttime1:
                  data[15] && data[15] != "" ? data[15].toString().trim() : "",
                additionalvideo1:
                  data[16] && data[16] != "" ? data[16].toString().trim() : "",
                restrictstarttime2:
                  data[17] && data[17] != "" ? data[17].toString().trim() : "",
                additionalvideo2:
                  data[18] && data[18] != "" ? data[18].toString().trim() : "",
                restrictstarttime3:
                  data[19] && data[19] != "" ? data[19].toString().trim() : "",
                additionalvideo3:
                  data[20] && data[20] != "" ? data[20].toString().trim() : "",
                restrictstarttime4:
                  data[21] && data[21] != "" ? data[21].toString().trim() : "",
                additionalvideo4:
                  data[22] && data[22] != "" ? data[22].toString().trim() : "",
                restrictstarttime5:
                  data[23] && data[23] != "" ? data[23].toString().trim() : "",
                file1:
                  data[24] && data[24] != "" ? data[24].toString().trim() : "",
                file2:
                  data[25] && data[25] != "" ? data[25].toString().trim() : "",
                file3:
                  data[26] && data[26] != "" ? data[26].toString().trim() : "",
                file4:
                  data[27] && data[27] != "" ? data[27].toString().trim() : "",
                file5:
                  data[28] && data[28] != "" ? data[28].toString().trim() : "",
                sendpush:
                  data[29] && data[29] != "" ? data[29].toString().trim() : "",
                pushmessage:
                  data[30] && data[30] != "" ? data[30].toString().trim() : "",
              });
            }
          });
          // console.log("modifiedArr :- ", modifiedArr);

          var groupped = _.groupBy(modifiedArr, function (n) {
            return n.sessiondate;
          }); // Grouping array by date

          // console.log("groupped : - ", groupped);

          var ErrorDataArr = [];
          modifiedArr.map((obj, id) => {
            var arrItem = JSON.parse(JSON.stringify(obj));
            var errors = [];

            if (arrItem.sessiondate === "") {
              errors.push(`Date: ${LocaleStrings.small_required}`);
            } else {
              if (!checkDateFormatYMD(arrItem.sessiondate)) {
                errors.push(
                  `${LocaleStrings.schedule_import_note_date_format}`
                );
              } else if (!moment(arrItem.sessiondate).isValid()) {
                errors.push(
                  `${LocaleStrings.schedule_import_note_date_format}`
                );
              } else if (!eventDate.includes(arrItem.sessiondate)) {
                errors.push(`${LocaleStrings.schedule_import_date_invalid}`);
              }
            }
            if (arrItem.sessiontrack === "") {
              errors.push(`Track: ${LocaleStrings.small_required}`);
            } else if (arrItem.sessiontrack) {
              let sameDateAllTracks = groupped[arrItem.sessiondate];
              let getAllTracksOnly = _.uniq(
                _.map(sameDateAllTracks, "sessiontrack")
              );

              let getNoTrack = _.filter(getAllTracksOnly, (o) => {
                return o === "notrack";
              });
              // console.log("getNoTrack :- ", getNoTrack);
              let getNormalTrack = _.filter(getAllTracksOnly, (o) => {
                return o !== "notrack";
              });
              // console.log("getNormalTrack :- ", getNormalTrack);
              if (getNoTrack.length > 0 && getNormalTrack.length > 0) {
                errors.push(
                  `Track: ${LocaleStrings.schedule_import_track_notrack_validation}`
                );
              }
            }
            if (arrItem.sessiontitle === "") {
              errors.push(`Title: ${LocaleStrings.small_required}`);
            }
            if (arrItem.sessionstime === "") {
              errors.push(`Start Time: ${LocaleStrings.small_required}`);
            } else if (
              arrItem.sessionstime != "" &&
              !moment(arrItem.sessionstime, "HH:mm", true).isValid() &&
              !moment(arrItem.sessionstime, "HH:m", true).isValid() &&
              !moment(arrItem.sessionstime, "H:mm", true).isValid() &&
              !moment(arrItem.sessionstime, "H:m", true).isValid()
            ) {
              errors.push(`Start Time: Use HH:MM format`);
            }
            if (arrItem.sessionetime === "") {
              errors.push(`End Time: ${LocaleStrings.small_required}`);
            } else if (
              arrItem.sessionetime != "" &&
              !moment(arrItem.sessionetime, "HH:mm", true).isValid() &&
              !moment(arrItem.sessionetime, "HH:m", true).isValid() &&
              !moment(arrItem.sessionetime, "H:mm", true).isValid() &&
              !moment(arrItem.sessionetime, "H:m", true).isValid()
            ) {
              errors.push(`End Time: Use HH:MM format`);
            }

            if (
              arrItem.sessionstime != "" &&
              arrItem.sessionetime != "" &&
              moment(arrItem.sessionstime, "HH:mm").format("HH:mm") >
                moment(arrItem.sessionetime, "HH:mm").format("HH:mm")
            ) {
              errors.push(
                `${LocaleStrings.schedule_import_starttime_greater_than_endtime_error_string}`
              );
            }

            if (errors.length > 0) {
              // storing errors
              arrItem.hasErrors = errors;
              ErrorDataArr.push(arrItem);
            }
          });
          // console.log("ErrorDataArr :- ", ErrorDataArr);

          var pageNumber = 1;
          var dataArray = ErrorDataArr.length > 0 ? ErrorDataArr : modifiedArr;
          var paginatedData = this.getPaginatedItems(dataArray, pageNumber);
          this.setState({
            hasData: true,
            hasDataError: ErrorDataArr.length > 0,
            importeddata: dataArray,
            selectedPage: pageNumber,
            paginatedData,
          });
        } else {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.schedule_import_validation3,
          });
        }
      } else {
        this.setState({
          hasError: true,
          errorMessage: LocaleStrings.schedule_import_validation2,
        });
      }
    } else {
      this.setState({
        hasError: true,
        errorMessage: LocaleStrings.schedule_import_validation2,
      });
    }
  };

  onOptionChange = (e) => {
    let clickedValue = e.target.value;

    this.setState({
      duplicateData: clickedValue,
    });
  };

  importFinalData = () => {
    this.setState({ loading: true });
    this.props.importSchedules(
      this.props.session,
      this.state.importeddata,
      this.state.duplicateData,
      (response) => {
        this.setState({ loading: false });
        if (response.success === 0) {
          this.props.showError(LocaleStrings.schedule_import_validation4);
        } else if (response.success === 2) {
          this.props.showError(LocaleStrings.schedule_import_validation5);
        } else {
          this.props.callbackFinalData();
          this.closeModal();
          this.props.showSuccess(LocaleStrings.schedule_import_success);
        }
      }
    );
  };

  getPaginatedItems = (items, page) => {
    var page = page || 1,
      per_page = 10,
      offset = (page - 1) * per_page,
      paginatedItems = _.drop(items, offset).slice(0, per_page);
    return {
      page: page,
      per_page: per_page,
      total: items.length,
      total_pages: Math.ceil(items.length / per_page),
      data: paginatedItems,
    };
  };

  paginationCallback = (pageNumber) => {
    if (this.state.selectedPage !== pageNumber) {
      var paginatedData = this.getPaginatedItems(
        this.state.importeddata,
        pageNumber
      );
      this.setState({ selectedPage: pageNumber, paginatedData });
    }
  };

  renderHeader = () => {
    return _.map(sheetHeader, (item, index) => {
      return <th key={`sheet_header_${index}`}>{item}</th>;
    });
  };

  renderItems = () => {
    let { paginatedData } = this.state;
    // console.log('paginatedData :- ',paginatedData)

    return _.map(paginatedData.data, (item, index) => {
      return <ImportCell key={`key_${index}`} listitem={item} />;
    });
  };

  render() {
    const { showModal, bulkEditModal } = this.props,
      {
        accept,
        processingData,
        hasData,
        hasError,
        hasDataError,
        errorMessage,
        paginatedData,
        duplicateData,
      } = this.state;

    var pageCount = paginatedData.total_pages;
    var totalImported = paginatedData.total;
    var defaultModalClass = hasData ? "xl" : "lg";

    return (
      <div>
        {/* ----- USE | WORKING :: Old simple input button ----- */}
        {/* <Button
          bsStyle=""
          type="button"
          className="btn-custom-blue schedule-add-button vertical-align-center"
          onClick={this.openModal}
        >
          <span className="font-icomoon i-custom-ms">
            {AppIcons.uploadericon}
          </span>
          &nbsp;
          {LocaleStrings.button_csv_xml_import}
        </Button> */}

        {/* ----- HIDE | NOT READY :: New dropdown merging both import and bulk edit ----- */}
        <div className="dropdown-btn-container">
          <DropdownButton
            className="dropdown-blue-btn"
            title={LocaleStrings.schedule_button_dropdown_title_import_edit}
            key="1"
            id="dropdown-basic-2"
            nocaret="true"
          >
            <Dropdown.Item value="import_sessions" onClick={this.openModal}>
              {LocaleStrings.schedule_button_dropdown_import}
            </Dropdown.Item>
            <Dropdown.Item value="tracks" onClick={this.openBulkEditModal}>
              {LocaleStrings.schedule_button_dropdown_bulk_edit}
              <span className="ps-1">
                <BetaFeature />
              </span>
            </Dropdown.Item>
          </DropdownButton>
        </div>

        <div>
          {!_.isEmpty(bulkEditModal) && bulkEditModal.show ? (
            <>
              <ScheduleBulkEdit history={this.props.history} />
            </>
          ) : (
            <>
              <Modal
                className="modal-container"
                show={showModal.show === true ? true : false}
                onHide={this.closeModal}
                animation={true}
                dialogClassName={defaultModalClass}
                size={"xl"}
              >
                <Modal.Header>
                  <div className="import-modal-title">
                    {LocaleStrings.schedule_import_header}
                  </div>
                  <button
                    type="button"
                    className="i-custom-cross-popup pull-right"
                    onClick={() => this.closeModal()}
                  >
                    <img
                      className="i-custom-small"
                      src="../../style/images/custom-icons/cross-black.png"
                    />
                  </button>
                </Modal.Header>

                <Modal.Body style={hasData ? { height: 530 } : {}}>
                  {processingData ? (
                    hasData ? (
                      <div className="imported-users">
                        {hasDataError ? (
                          <div className="custom-text1-primary-medium">
                            {LocaleStrings.import_error_rows_message}.
                          </div>
                        ) : (
                          ""
                        )}
                        <table className="table new-table">
                          <thead>
                            <tr>
                              <th>1</th>
                              {this.renderHeader()}
                            </tr>
                          </thead>

                          <tbody>{this.renderItems()}</tbody>
                        </table>

                        {!hasError && hasData && pageCount > 1 ? (
                          <div style={{ marginTop: "16px" }}>
                            <Pagination
                              activePage={this.state.selectedPage}
                              itemsCountPerPage={per_page_row}
                              totalItemsCount={totalImported}
                              pageRangeDisplayed={per_page_row}
                              onChange={this.paginationCallback}
                              className="importuser-pagination"
                            />
                          </div>
                        ) : null}
                      </div>
                    ) : hasError ? (
                      <div className="import-error">
                        <div>{errorMessage}</div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-custom-delete"
                            onClick={this.retry}
                          >
                            <i className="glyphicon glyphicon-repeat pull-left import-retry"></i>{" "}
                            {LocaleStrings.button_retry}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>{LocaleStrings.processing_data}..</div>
                    )
                  ) : (
                    <div className="row">
                      <div className="col-sm-6 col-sm-offset-0 imgPreview">
                        <section>
                          <div className="dropzone">
                            <Dropzone
                              onDrop={this.onDrop.bind(this)}
                              accept={accept}
                              multiple={false}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div
                                  {...getRootProps()}
                                  className="importdropbox"
                                >
                                  <input {...getInputProps()} />
                                  <div className="import-drop-text">
                                    <div>
                                      <img
                                        src={`${NEW_IMAGE_PATH}upload.png`}
                                      />
                                    </div>
                                    <div>
                                      {
                                        LocaleStrings.drag_drop_textupload_template
                                      }
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            {/* <Dropzone
                          className="importdropbox"
                          accept={accept}
                          onDrop={this.onDrop.bind(this)}
                        >
                          <div className="import-drop-text">
                            <div>
                              <img src={`${NEW_IMAGE_PATH}upload.png`} />
                            </div>
                            <div>
                              {LocaleStrings.drag_drop_textupload_template}
                            </div>
                          </div>
                        </Dropzone> */}
                          </div>
                        </section>
                      </div>
                      <div className="col-sm-6 col-sm-offset-0">
                        <div className="import-title text-capitalize">
                          {LocaleStrings.download_template}
                        </div>
                        <div className="import-subtitle">
                          {
                            LocaleStrings.schedule_import_download_template_subtitle
                          }
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <div className="import-option">
                            <a
                              className="users-link"
                              onClick={() => this.downloadSample("csv")}
                            >
                              <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                              <span className="import-option-button">
                                {LocaleStrings.sample_csv}
                              </span>
                            </a>
                          </div>
                          <div className="import-option">
                            <a
                              className="users-link"
                              onClick={() => this.downloadSample("xlsx")}
                            >
                              <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                              <span className="import-option-button">
                                {LocaleStrings.sample_xls}
                              </span>
                            </a>
                          </div>
                          <div className="import-option">
                            <img
                              className="xls-sample-img"
                              src={`${NEW_IMAGE_PATH}schedule_xls_template.png`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-sm-12 import-notes mt-10">
                        <ul>
                          <li className="import-notes-title">
                            {LocaleStrings.notes}
                          </li>
                          <li>- {LocaleStrings.column_header_format}</li>
                          <li>- {LocaleStrings.invalid_import_info}</li>
                          <li>
                            - {LocaleStrings.schedule_import_note_date_format}
                          </li>
                          <li>
                            - {LocaleStrings.schedule_import_note_time_format}
                          </li>
                          <li>
                            - {LocaleStrings.schedule_import_note_notrack1}
                          </li>
                          <li>
                            - {LocaleStrings.schedule_import_note_notrack2}
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </Modal.Body>

                {hasData && totalImported > 0 && !hasDataError ? (
                  <Modal.Footer>
                    <div>
                      <b>
                        {
                          LocaleStrings.schedule_import_text_action_on_uploaded_data
                        }
                      </b>
                      <span style={{ padding: "0px 20px" }}>
                        <input
                          type="radio"
                          value="update"
                          name="actionwithdata"
                          checked={duplicateData == "update" ? true : false}
                          onChange={this.onOptionChange.bind(this)}
                        />{" "}
                        {LocaleStrings.overwrite}
                      </span>
                      <span>
                        <input
                          type="radio"
                          value="insert"
                          name="actionwithdata"
                          checked={duplicateData == "insert" ? true : false}
                          onChange={this.onOptionChange.bind(this)}
                        />{" "}
                        {LocaleStrings.skip}
                      </span>
                    </div>

                    <div>
                      <Button
                        bsStyle=""
                        className="btn-custom-blue"
                        loading={this.state.loading}
                        type="button"
                        onClick={this.importFinalData.bind(this)}
                      >
                        {LocaleStrings.import}
                      </Button>
                    </div>
                  </Modal.Footer>
                ) : (
                  <Modal.Footer>
                    {hasDataError ? (
                      <Button
                        bsStyle=""
                        className="btn-custom-delete"
                        onClick={this.retry}
                      >
                        {LocaleStrings.button_retry}
                      </Button>
                    ) : (
                      ""
                    )}
                    <Button
                      bsStyle=""
                      className="btn-custom-white"
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.button_close}
                    </Button>
                  </Modal.Footer>
                )}
              </Modal>
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var dates = [];
  if (state.scheduleData.payload.scheduledates_by_eventid)
    var scheduledates =
      state.scheduleData.payload.scheduledates_by_eventid.filter(
        (date) => date.isactive
      );
  var sortArrAvailable = _.sortBy(scheduledates, "scheduledate", "asc");
  dates = sortArrAvailable;

  return {
    session: state.session,
    showModal: state.scheduleImportModal,
    bulkEditModal: state.bulkEditModalControlReducer,
    dates,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  importScheduleModal,
  importSchedules,
  handleBulkEditModal,
})(ImportSchedules);
